module.exports = __webpack_public_path__ + "static/dev_activity-c8b29cad7b2e08c2365da33e4fd5dff2.svg";